<template lang='pug'>
    div
        ElectricalPDSensorSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'en'")

            section.title-container
                h1.product-title ZM3
                h2.product-subtitle Three Phase Coupling Device for Partial Discharge Measurement according to IEC 60270

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/ZM3.webp')
                            img( src='@/assets/photos/product_shots/ZM3.png', width="70%", alt='ZM3 PD Coupling Device', title='ZM3 PD Coupling Device')
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Three-phase PD measurement impedance according to IEC 60270
                                li For charge-based PD measurement using coupling capacitors
                                //- li Available with 1 - 30 &#x00B5;F secondary capacitance
                                li 3 multiplexed PD input channels, 1 PD output with DC bias supply provided by PDM-80
                                //- li Integrated clipping detection and attenuation switch

                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet ZM3.pdf")
                            Maillink(to='support@bss-hs.de', sub='ZM3', text='Contact Us', size=30, strokeWidth=2)
                            Sitelink(to="/en/products/pdm-80", text='PD Monitoring System PDM-80')

            section.margin-bottom
                p The ZM3 is a 3-phase coupling device (PD measuring impedance) specially designed for PD measurement on medium-voltage switchgear. It is adapted to the capacitance ratios of the capacitive couplers integrated for voltage indicators. The ZM3 can be used with or without voltage indicators on both HR and LR systems.
                p The PDM-80 and 8 ZM3 can be used to permanently monitor all three-phases of 8 medium voltage switchgear panels on PD.
                p The ZM3 is phantom powered by the PDM-80 via the test lead.


        div.fullwidth(v-if="$route.params.lang == 'de'")

            section.title-container
                h1.product-title ZM3
                h2.product-subtitle Dreiphasiger Ankoppelvierpol für die Teilentladungsmessung nach IEC 60270

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/ZM3.webp')
                            img( src='@/assets/photos/product_shots/ZM3.png', width="70%", alt='ZM3 TE-Messimpedanz', title='ZM3 TE-Messimpedanz')
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Dreiphasiger Ankoppelvierpol für die TE-Messung nach IEC 60270
                                li Für die ladungsbasierte TE-Messung an Koppelkapazitäten
                                //- li Erhältlich mit 1 - 30 &#x00B5;F sekundärer Kapazität
                                li 3 TE-Eingangskanäle (multiplexed), 1 TE-Ausgang mit DC-Phantomspeisung durch das PDM-80
                                //- li Integrierte Clipping-Erkennung und Dämpfungsschalter
                        .bluebox
                            Downloadlink(text='Datenblatt (pdf, englisch)', link="/pdf/Datasheet ZM3.pdf")
                            Maillink(to='support@bss-hs.de', sub='ZM3', text='Kontakt', size=30, strokeWidth=2)
                            Sitelink(to="/de/products/pdm-80", text='TE-Monitoringsystem PDM-80')
                        
            section.margin-bottom
                p Der ZM3 ist ein 3-phasiger Ankoppelvierpol (TE-Messimpedanz) speziell entwickelt für die TE-Messung an Mittelspannungsschaltanlagen. Er ist angepasst an die Kapazitätsverhältnisse der für Spannungsanzeiger integrierten kapazitiven Koppler. Der ZM3 kann mit oder ohne Spannungsanzeiger an sowohl HR als auch LR Systemen verwendet werden.
                p Mit dem PDM-80 und 8 ZM3 können 8 Mittelspannungsschaltanlagen-Panels dreiphasig auf TE dauerhaft überwacht werden.
                p Der ZM3 wird durch das PDM-80 über die Messleitung phantomgespeist.
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | ZM3",
            description:
                "Ankoppelvierpol mit 3 Eingangskanälen für die Teilentladungs(TE)-Messung an Mittelspannungsschaltanlagen",
        },
        en: {
            title: "BSS | ZM3",
            description:
                "PD Coupling device (PD Sensor) with 3 input channels for Partial Discharge Measurement at MV Switchgear",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>